// Language translations for the website

export const translations = {
  en: {
    // Navigation
    nav: {
      home: "Home",
      about: "About Us",
      services: "Services",
      events: "Events Management",
      cme: "Training Courses",
      clients: "Our Clients",
      contact: "Contact Us"
    },
    
    // Home Page
    home: {
      ourServices: "OUR SERVICES",
      knowMore: "Know More",
      heroTitle: "Target For Health Consulting",
      heroSubtitle: "Where the success of your health establishment is our Target"
    },
    
    // About Page
    about: {
      title: "About Us",
      mainTitle: "TARGET FOR HEALTH CONSULTING",
      ourMission: "Our Mission",
      missionText: "To provide exceptional healthcare consulting services that empower healthcare organizations to achieve operational excellence, regulatory compliance, and sustainable growth in the dynamic healthcare landscape.",
      ourVision: "Our Vision",
      visionText: "To be the leading healthcare consulting partner in the UAE and beyond, recognized for our commitment to quality, innovation, and the success of our clients' healthcare establishments.",
      whyChoose: "Why Choose Us?",
      expertTeam: "Expert Team",
      expertTeamDesc: "Experienced healthcare professionals with deep industry knowledge",
      provenTrack: "Proven Track Record",
      provenTrackDesc: "Successfully serving healthcare organizations since 2017",
      comprehensiveServices: "Comprehensive Services",
      comprehensiveServicesDesc: "Full spectrum of healthcare consulting and training solutions",
      regulatoryCompliance: "Regulatory Compliance",
      regulatoryComplianceDesc: "Ensuring adherence to local and international healthcare standards",
      clientCentered: "Client-Centered Approach",
      clientCenteredDesc: "Tailored solutions designed to meet your specific needs",
      continuousSupport: "Continuous Support",
      continuousSupportDesc: "Ongoing guidance and support throughout your journey"
    },
    
    // Services Page
    services: {
      title: "Our Services",
      mainTitle: "COMPREHENSIVE HEALTHCARE SOLUTIONS",
      subtitle: "We offer a full range of healthcare consulting services designed to help your organization achieve excellence in operations, compliance, and patient care.",
      learnMore: "Learn More",
      backToServices: "Back to All Services",
      aboutService: "About This Service",
      keyBenefits: "Key Benefits",
      expertGuidance: "Expert Guidance",
      expertGuidanceDesc: "Professional advice from experienced healthcare consultants",
      complianceAssurance: "Compliance Assurance",
      complianceAssuranceDesc: "Meet local and international healthcare standards",
      improvedEfficiency: "Improved Efficiency",
      improvedEfficiencyDesc: "Optimize operations and reduce costs",
      qualityEnhancement: "Quality Enhancement",
      qualityEnhancementDesc: "Elevate the quality of care and services",
      getStarted: "Get Started Today",
      getStartedText: "Ready to improve your healthcare organization with our",
      getStartedQuestion: "service?",
      contactUs: "Contact Us"
    },
    
    // Events Page
    events: {
      title: "Events Management",
      mainTitle: "UPCOMING EVENTS",
      comingSoon: "Coming Soon",
      comingSoonText: "We're organizing exciting healthcare events, seminars, and workshops. Stay tuned for updates!"
    },
    
    // CME Page
    cme: {
      title: "CME & Medical Staff Training",
      mainTitle: "CONTINUING MEDICAL EDUCATION",
      subtitle: "Accredited CME programs covering a wide range of medical and dental specialties. Stay updated with the latest medical knowledge and best practices.",
      currentPrograms: "Current Training Programs",
      duration: "Duration",
      certificate: "Certificate",
      credits: "Credits",
      startDate: "Start Date",
      dates: "Dates",
      location: "Location",
      downloadMaterials: "Download Course Materials",
      registerHere: "Send Request",
      limitedSeats: "Limited seats available - Register early!",
      whyChoose: "Why Choose Our Training Programs?",
      accreditedPrograms: "Accredited Programs",
      accreditedProgramsDesc: "All courses are officially accredited",
      expertInstructors: "Expert Instructors",
      expertInstructorsDesc: "Learn from experienced professionals",
      comprehensiveMaterials: "Comprehensive Materials",
      comprehensiveMaterialsDesc: "Complete learning resources provided",
      flexibleScheduling: "Flexible Scheduling",
      flexibleSchedulingDesc: "Multiple sessions to fit your schedule",
      previousCourses: "Previous Courses Archive",
      futureCourses: "Future Training Programs",
      currentCourses: "Current Training Courses",
      viewPrevious: "View Previous Courses",
      viewFuture: "View Future Courses",
      viewCurrent: "View Current Courses",
      completed: "Completed",
      planned: "Planned",
      viewMaterials: "View Materials",
      viewDetails: "View Details",
      closeDetails: "Close",
      completedOn: "Completed On",
      plannedFor: "Planned For",
      courseNotes: "Notes",
      // Registration Form
      registrationForm: "Course Registration Request",
      fullName: "Full Name",
      emailAddress: "Email Address",
      contactNumber: "Contact Number",
      educationLevel: "Level of Education",
      requestedCourse: "Requested Course",
      additionalComments: "Additional Comments (Optional)",
      commentsPlaceholder: "Please share any questions or special requirements...",
      selectEducation: "Select your education level",
      highSchool: "High School",
      diploma: "Diploma",
      bachelor: "Bachelor's Degree",
      master: "Master's Degree",
      phd: "PhD",
      other: "Other",
      specifyEducation: "Please specify your education level",
      submitRequest: "Submit Request",
      teamWillContact: "Our training team will contact you soon to complete the registration process",
      requestSent: "Request Sent Successfully!",
      requestError: "Failed to send request. Please try again.",
      closeModal: "Close"
    },
    
    // Clients Page
    clients: {
      title: "Our Clients",
      mainTitle: "TRUSTED BY LEADING HEALTHCARE ORGANIZATIONS",
      comingSoon: "Coming Soon",
      comingSoonText: "We're proud to partner with prestigious healthcare organizations. Client portfolio will be showcased here soon!",
      whatClientsSay: "What Our Clients Say"
    },
    
    // Contact Page
    contact: {
      title: "Contact Us",
      mainTitle: "GET IN TOUCH",
      subtitle: "Have questions about our services? We'd love to hear from you. Send us a message and we'll respond as soon as possible.",
      contactInfo: "Contact Information",
      phoneFax: "Phone & Fax",
      email: "Email",
      address: "Address",
      sendMessage: "Send Us a Message",
      fullName: "Full Name",
      emailAddress: "Email Address",
      phoneNumber: "Phone Number",
      subject: "Subject",
      message: "Message",
      sending: "Sending...",
      sendBtn: "Send Message",
      required: "*"
    },
    
    // Footer
    footer: {
      aboutUs: "ABOUT US",
      navigation: "NAVIGATION",
      contactDetails: "CONTACT DETAILS",
      newsletter: "NEWS LETTER",
      copyright: "Target Health Copyright© 2026. Powered by Emirates Digital Solutions All right reserved.",
      emailPlaceholder: "Your email"
    }
  },
  
  ar: {
    // Navigation - القوائم
    nav: {
      home: "الرئيسية",
      about: "من نحن",
      services: "خدماتنا",
      events: "إدارة الفعاليات",
      cme: "الدورات التدريبية",
      clients: "عملاؤنا",
      contact: "اتصل بنا"
    },
    
    // Home Page - الصفحة الرئيسية
    home: {
      ourServices: "خدماتنا",
      knowMore: "اعرف المزيد",
      heroTitle: "تارجت للاستشارات الصحية",
      heroSubtitle: "حيث نجاح مؤسستك الصحية هو هدفنا"
    },
    
    // About Page - من نحن
    about: {
      title: "من نحن",
      mainTitle: "تارجت للاستشارات الصحية",
      ourMission: "رسالتنا",
      missionText: "تقديم خدمات استشارية صحية استثنائية تمكن المؤسسات الصحية من تحقيق التميز التشغيلي والامتثال التنظيمي والنمو المستدام في المشهد الصحي الديناميكي.",
      ourVision: "رؤيتنا",
      visionText: "أن نكون الشريك الاستشاري الصحي الرائد في دولة الإمارات وخارجها، معترف بنا لالتزامنا بالجودة والابتكار ونجاح المؤسسات الصحية لعملائنا.",
      whyChoose: "لماذا تختارنا؟",
      expertTeam: "فريق خبراء",
      expertTeamDesc: "محترفون في الرعاية الصحية ذوو خبرة واسعة في المجال",
      provenTrack: "سجل حافل مثبت",
      provenTrackDesc: "نخدم المؤسسات الصحية بنجاح منذ عام 2017",
      comprehensiveServices: "خدمات شاملة",
      comprehensiveServicesDesc: "مجموعة كاملة من الاستشارات والتدريب الصحي",
      regulatoryCompliance: "الامتثال التنظيمي",
      regulatoryComplianceDesc: "ضمان الالتزام بالمعايير الصحية المحلية والدولية",
      clientCentered: "نهج يركز على العميل",
      clientCenteredDesc: "حلول مصممة خصيصاً لتلبية احتياجاتك المحددة",
      continuousSupport: "دعم مستمر",
      continuousSupportDesc: "إرشاد ودعم مستمر طوال رحلتك"
    },
    
    // Services Page - الخدمات
    services: {
      title: "خدماتنا",
      mainTitle: "حلول رعاية صحية شاملة",
      subtitle: "نقدم مجموعة كاملة من خدمات الاستشارات الصحية المصممة لمساعدة مؤسستك على تحقيق التميز في العمليات والامتثال ورعاية المرضى.",
      learnMore: "اعرف المزيد",
      backToServices: "العودة إلى جميع الخدمات",
      aboutService: "عن هذه الخدمة",
      keyBenefits: "الفوائد الرئيسية",
      expertGuidance: "إرشاد الخبراء",
      expertGuidanceDesc: "مشورة مهنية من مستشارين صحيين ذوي خبرة",
      complianceAssurance: "ضمان الامتثال",
      complianceAssuranceDesc: "تلبية المعايير الصحية المحلية والدولية",
      improvedEfficiency: "تحسين الكفاءة",
      improvedEfficiencyDesc: "تحسين العمليات وتقليل التكاليف",
      qualityEnhancement: "تحسين الجودة",
      qualityEnhancementDesc: "رفع مستوى جودة الرعاية والخدمات",
      getStarted: "ابدأ اليوم",
      getStartedText: "هل أنت مستعد لتحسين مؤسستك الصحية من خلال خدمة",
      getStartedQuestion: "لدينا؟",
      contactUs: "اتصل بنا"
    },
    
    // Events Page - الفعاليات
    events: {
      title: "إدارة الفعاليات",
      mainTitle: "الفعاليات القادمة",
      comingSoon: "قريباً",
      comingSoonText: "نحن بصدد تنظيم فعاليات وندوات وورش عمل صحية مثيرة. ترقبوا التحديثات!"
    },
    
    // CME Page - التعليم الطبي المستمر
    cme: {
      title: "التعليم الطبي المستمر وتدريب الكوادر الطبية",
      mainTitle: "التعليم الطبي المستمر",
      subtitle: "برامج تعليم طبي مستمر معتمدة تغطي مجموعة واسعة من التخصصات الطبية وطب الأسنان. ابق على اطلاع بأحدث المعارف الطبية وأفضل الممارسات.",
      currentPrograms: "البرامج التدريبية الحالية",
      duration: "المدة",
      certificate: "الشهادة",
      credits: "الساعات المعتمدة",
      startDate: "تاريخ البدء",
      dates: "التواريخ",
      location: "الموقع",
      downloadMaterials: "تحميل المواد الدراسية",
      registerHere: "ارسل طلب",
      limitedSeats: "المقاعد محدودة - سجل مبكراً!",
      whyChoose: "لماذا تختار برامجنا التدريبية؟",
      accreditedPrograms: "برامج معتمدة",
      accreditedProgramsDesc: "جميع الدورات معتمدة رسمياً",
      expertInstructors: "مدربون خبراء",
      expertInstructorsDesc: "تعلم من محترفين ذوي خبرة",
      comprehensiveMaterials: "مواد شاملة",
      comprehensiveMaterialsDesc: "موارد تعليمية كاملة متوفرة",
      flexibleScheduling: "جدولة مرنة",
      flexibleSchedulingDesc: "جلسات متعددة تناسب جدولك الزمني",
      previousCourses: "أرشيف الدورات السابقة",
      futureCourses: "البرامج التدريبية المستقبلية",
      currentCourses: "الدورات التدريبية الحالية",
      viewPrevious: "عرض الدورات السابقة",
      viewFuture: "عرض الدورات المستقبلية",
      viewCurrent: "عرض الدورات الحالية",
      completed: "مكتمل",
      planned: "مخطط لها",
      viewMaterials: "عرض المواد",
      viewDetails: "عرض التفاصيل",
      closeDetails: "إغلاق",
      completedOn: "تم إكماله في",
      plannedFor: "مخطط لـ",
      courseNotes: "ملاحظات",
      // Registration Form - نموذج التسجيل
      registrationForm: "طلب التسجيل في الدورة",
      fullName: "الاسم الكامل",
      emailAddress: "البريد الإلكتروني",
      contactNumber: "رقم الاتصال",
      educationLevel: "المستوى التعليمي",
      requestedCourse: "الدورة المطلوبة",
      additionalComments: "ملاحظات إضافية (اختياري)",
      commentsPlaceholder: "يرجى مشاركة أي أسئلة أو متطلبات خاصة...",
      selectEducation: "اختر مستواك التعليمي",
      highSchool: "الثانوية العامة",
      diploma: "دبلوم",
      bachelor: "بكالوريوس",
      master: "ماجستير",
      phd: "دكتوراه",
      other: "أخرى",
      specifyEducation: "يرجى تحديد مستواك التعليمي",
      submitRequest: "إرسال الطلب",
      teamWillContact: "سيتواصل معك فريق التدريب قريباً لإكمال عملية التسجيل",
      requestSent: "تم إرسال الطلب بنجاح!",
      requestError: "فشل إرسال الطلب. يرجى المحاولة مرة أخرى.",
      closeModal: "إغلاق"
    },
    
    // Clients Page - العملاء
    clients: {
      title: "عملاؤنا",
      mainTitle: "موثوق بنا من قبل المؤسسات الصحية الرائدة",
      comingSoon: "قريباً",
      comingSoonText: "نفخر بالشراكة مع مؤسسات صحية مرموقة. سيتم عرض محفظة العملاء هنا قريباً!",
      whatClientsSay: "ماذا يقول عملاؤنا"
    },
    
    // Contact Page - اتصل بنا
    contact: {
      title: "اتصل بنا",
      mainTitle: "تواصل معنا",
      subtitle: "هل لديك أسئلة حول خدماتنا؟ نحن نحب أن نسمع منك. أرسل لنا رسالة وسنرد في أقرب وقت ممكن.",
      contactInfo: "معلومات الاتصال",
      phoneFax: "الهاتف والفاكس",
      email: "البريد الإلكتروني",
      address: "العنوان",
      sendMessage: "أرسل لنا رسالة",
      fullName: "الاسم الكامل",
      emailAddress: "البريد الإلكتروني",
      phoneNumber: "رقم الهاتف",
      subject: "الموضوع",
      message: "الرسالة",
      sending: "جاري الإرسال...",
      sendBtn: "إرسال الرسالة",
      required: "*"
    },
    
    // Footer - التذييل
    footer: {
      aboutUs: "من نحن",
      navigation: "التنقل",
      contactDetails: "تفاصيل الاتصال",
      newsletter: "النشرة الإخبارية",
      copyright: "تارجت للصحة © 2026. بدعم من حلول الإمارات الرقمية. جميع الحقوق محفوظة.",
      emailPlaceholder: "بريدك الإلكتروني"
    }
  }
};

// Service translations
export const serviceTranslations = {
  en: [
    {
      id: 1,
      title: "Claims Consulting",
      shortDescription: "Review and assess the medical claims randomly or periodically. Provide advisory support to the clinical team to grant...",
      fullDescription: "Review and assess the medical claims randomly or periodically. Provide advisory support to the clinical team to grant appropriate medical services according to the patient's condition and benefits. Confirm the accuracy of the medical claims processing and the correctness of the CPT and ICD-10 coding and modifiers. Review denied claims and provide advisory support to re-submit if applicable."
    },
    {
      id: 2,
      title: "Medical Records Consulting",
      shortDescription: "Qualify and train your staff on how to collect, document, save, archive and re-call the medical information and the...",
      fullDescription: "Qualify and train your staff on how to collect, document, save, archive and re-call the medical information and the health records according to the local health authority guidelines and international standards. Review and assess the applied documentation systems and recommend proper improvements to enhance the quality of the medical records management."
    },
    {
      id: 3,
      title: "Insured Patients",
      shortDescription: "Provide advisory support to all patients regarding the medical insurance system and their benefits and exclusions,...",
      fullDescription: "Provide advisory support to all patients regarding the medical insurance system and their benefits and exclusions, pre-authorizations and approvals required before accessing the healthcare services. Assist patients in understanding their insurance coverage and help them navigate through the complexities of the healthcare insurance system."
    },
    {
      id: 4,
      title: "Data Analysis Consulting",
      shortDescription: "Provide advisory support for the establishment's growth and performance according to the health market demands and...",
      fullDescription: "Provide advisory support for the establishment's growth and performance according to the health market demands and requirements. Analyze healthcare data to identify trends, patterns, and opportunities for improvement. Generate comprehensive reports and insights to support strategic decision-making and operational excellence."
    },
    {
      id: 5,
      title: "Admin Consulting",
      shortDescription: "Review and assess applied policies and procedures and optimize them to meet the local health authority guidelines and to...",
      fullDescription: "Review and assess applied policies and procedures and optimize them to meet the local health authority guidelines and to meet international standards. Develop and implement efficient administrative systems and workflows. Provide training and support to administrative staff to ensure compliance and operational efficiency."
    },
    {
      id: 6,
      title: "Technical Consulting",
      shortDescription: "Qualify your staff by supplying them with information and experiences which were designed on high standard levels to...",
      fullDescription: "Qualify your staff by supplying them with information and experiences which were designed on high standard levels to meet the local and international requirements. Provide technical expertise in healthcare systems, equipment, and technology implementation. Support digital transformation initiatives in healthcare facilities."
    },
    {
      id: 7,
      title: "Events Management",
      shortDescription: "Establishing, organizing and managing any type of medical events, seminars, work-shops and conferences. Very far beyond...",
      fullDescription: "Establishing, organizing and managing any type of medical events, seminars, workshops and conferences. We handle everything from venue selection to speaker coordination, registration management, and post-event follow-up. Our team ensures professional execution of healthcare events that deliver value to all participants."
    },
    {
      id: 8,
      title: "CME & Medical Staff Training",
      shortDescription: "CME covering wide range of medical and dental specialties will be one of our concerns to assist the healthcare...",
      fullDescription: "CME covering wide range of medical and dental specialties will be one of our concerns to assist the healthcare professionals in maintaining their professional competence. We offer accredited continuing medical education programs designed by experts to keep healthcare professionals updated with the latest medical knowledge and best practices."
    },
    {
      id: 9,
      title: "Elite Services",
      shortDescription: "Elevate your healthcare facility to new heights of excellence with our comprehensive suite of professional services...",
      fullDescription: `Elevate your healthcare facility to new heights of excellence with our comprehensive suite of professional services. Designed for forward-thinking healthcare organizations, our elite solutions combine advanced analytics, strategic insights, and proven methodologies to optimize your operations, maximize revenue, and ensure sustainable growth in today's competitive healthcare landscape.

📊 KPI Management & Performance Optimization
Navigate the newly implemented DOH KPIs with confidence. We specialize in helping Primary Healthcare Centers, Medical Centres, and Dental Centres establish, monitor, and achieve the Department of Health's mandatory performance indicators, ensuring full compliance while driving measurable improvements in service quality and operational excellence.

💰 Clinical Costing & Financial Intelligence
Master DOH-compliant clinical costing with precision. We prepare comprehensive cost analysis aligned with the Department of Health's requirements, ensuring accurate service costing, transparent financial reporting, and full regulatory compliance while optimizing profitability and operational efficiency.

🔄 Rejections Solutions & Claims Recovery
Minimize revenue leakage through intelligent claims management. We analyze rejection patterns, implement preventive strategies, and establish robust appeal processes to maximize your reimbursement rates and reduce claim denials.

📈 Revenue Cycle Analysis & Optimization
Unlock hidden revenue opportunities. Our comprehensive revenue analysis identifies bottlenecks, streamlines billing processes, and implements best practices to accelerate cash flow and improve your bottom line.

🛡️ Risk Management & Compliance Assurance
Protect your organization with proactive risk mitigation. We assess clinical, operational, and financial risks, develop customized mitigation strategies, and ensure full compliance with local and international healthcare regulations.

Partner with us to transform your healthcare facility into a high-performing, financially resilient organization that delivers exceptional patient care while achieving operational excellence.`
    }
  ],
  ar: [
    {
      id: 1,
      title: "استشارات المطالبات",
      shortDescription: "مراجعة وتقييم المطالبات الطبية بشكل عشوائي أو دوري. تقديم الدعم الاستشاري للفريق السريري لمنح...",
      fullDescription: "مراجعة وتقييم المطالبات الطبية بشكل عشوائي أو دوري. تقديم الدعم الاستشاري للفريق السريري لمنح الخدمات الطبية المناسبة وفقاً لحالة المريض والمزايا. تأكيد دقة معالجة المطالبات الطبية وصحة ترميز CPT وICD-10 والمعدلات. مراجعة المطالبات المرفوضة وتقديم الدعم الاستشاري لإعادة التقديم إذا كان ذلك ممكناً."
    },
    {
      id: 2,
      title: "استشارات السجلات الطبية",
      shortDescription: "تأهيل وتدريب موظفيك على كيفية جمع وتوثيق وحفظ وأرشفة واسترجاع المعلومات الطبية و...",
      fullDescription: "تأهيل وتدريب موظفيك على كيفية جمع وتوثيق وحفظ وأرشفة واسترجاع المعلومات الطبية والسجلات الصحية وفقاً لإرشادات السلطات الصحية المحلية والمعايير الدولية. مراجعة وتقييم أنظمة التوثيق المطبقة والتوصية بالتحسينات المناسبة لتعزيز جودة إدارة السجلات الطبية."
    },
    {
      id: 3,
      title: "المرضى المؤمنين",
      shortDescription: "تقديم الدعم الاستشاري لجميع المرضى فيما يتعلق بنظام التأمين الطبي ومزاياهم واستثناءاتهم...",
      fullDescription: "تقديم الدعم الاستشاري لجميع المرضى فيما يتعلق بنظام التأمين الطبي ومزاياهم واستثناءاتهم، والتصاريح المسبقة والموافقات المطلوبة قبل الوصول إلى الخدمات الصحية. مساعدة المرضى في فهم تغطيتهم التأمينية ومساعدتهم على التنقل عبر تعقيدات نظام التأمين الصحي."
    },
    {
      id: 4,
      title: "استشارات تحليل البيانات",
      shortDescription: "تقديم الدعم الاستشاري لنمو المؤسسة وأدائها وفقاً لمتطلبات سوق الصحة و...",
      fullDescription: "تقديم الدعم الاستشاري لنمو المؤسسة وأدائها وفقاً لمتطلبات ومتطلبات سوق الصحة. تحليل البيانات الصحية لتحديد الاتجاهات والأنماط وفرص التحسين. إنشاء تقارير ورؤى شاملة لدعم اتخاذ القرارات الاستراتيجية والتميز التشغيلي."
    },
    {
      id: 5,
      title: "الاستشارات الإدارية",
      shortDescription: "مراجعة وتقييم السياسات والإجراءات المطبقة وتحسينها لتلبية إرشادات السلطة الصحية المحلية و...",
      fullDescription: "مراجعة وتقييم السياسات والإجراءات المطبقة وتحسينها لتلبية إرشادات السلطة الصحية المحلية والمعايير الدولية. تطوير وتنفيذ أنظمة إدارية وسير عمل فعالة. توفير التدريب والدعم للموظفين الإداريين لضمان الامتثال والكفاءة التشغيلية."
    },
    {
      id: 6,
      title: "الاستشارات الفنية",
      shortDescription: "تأهيل موظفيك من خلال تزويدهم بالمعلومات والخبرات التي تم تصميمها على مستويات عالية من المعايير...",
      fullDescription: "تأهيل موظفيك من خلال تزويدهم بالمعلومات والخبرات التي تم تصميمها على مستويات عالية من المعايير لتلبية المتطلبات المحلية والدولية. توفير الخبرة الفنية في الأنظمة الصحية والمعدات وتنفيذ التكنولوجيا. دعم مبادرات التحول الرقمي في المرافق الصحية."
    },
    {
      id: 7,
      title: "إدارة الفعاليات",
      shortDescription: "إنشاء وتنظيم وإدارة أي نوع من الفعاليات الطبية والندوات وورش العمل والمؤتمرات...",
      fullDescription: "إنشاء وتنظيم وإدارة أي نوع من الفعاليات الطبية والندوات وورش العمل والمؤتمرات. نتعامل مع كل شيء من اختيار المكان إلى تنسيق المتحدثين وإدارة التسجيل والمتابعة بعد الحدث. يضمن فريقنا التنفيذ الاحترافي للفعاليات الصحية التي تقدم قيمة لجميع المشاركين."
    },
    {
      id: 8,
      title: "التعليم الطبي المستمر وتدريب الكوادر الطبية",
      shortDescription: "التعليم الطبي المستمر يغطي مجموعة واسعة من التخصصات الطبية وطب الأسنان سيكون أحد اهتماماتنا...",
      fullDescription: "التعليم الطبي المستمر يغطي مجموعة واسعة من التخصصات الطبية وطب الأسنان سيكون أحد اهتماماتنا لمساعدة المهنيين الصحيين في الحفاظ على كفاءتهم المهنية. نقدم برامج تعليم طبي مستمر معتمدة مصممة من قبل خبراء لإبقاء المهنيين الصحيين على اطلاع بأحدث المعارف الطبية وأفضل الممارسات."
    },
    {
      id: 9,
      title: "الخدمات المتميزة",
      shortDescription: "ارتقِ بمؤسستك الصحية إلى آفاق جديدة من التميز مع مجموعتنا الشاملة من الخدمات الاحترافية...",
      fullDescription: `ارتقِ بمؤسستك الصحية إلى آفاق جديدة من التميز مع مجموعتنا الشاملة من الخدمات الاحترافية. مصممة خصيصاً للمؤسسات الصحية الطموحة، حلولنا المتميزة تجمع بين التحليلات المتقدمة والرؤى الاستراتيجية والمنهجيات المثبتة لتحسين عملياتك وتعظيم الإيرادات وضمان النمو المستدام في بيئة الرعاية الصحية التنافسية اليوم.

📊 إدارة مؤشرات الأداء الرئيسية وتحسين الأداء
تنقل بثقة عبر مؤشرات الأداء الرئيسية الجديدة لدائرة الصحة. نحن متخصصون في مساعدة مراكز الرعاية الصحية الأولية والمراكز الطبية ومراكز طب الأسنان على إنشاء ومراقبة وتحقيق مؤشرات الأداء الإلزامية لدائرة الصحة، مما يضمن الامتثال الكامل مع تحقيق تحسينات قابلة للقياس في جودة الخدمة والتميز التشغيلي.

💰 التكلفة السريرية والذكاء المالي
أتقن التكلفة السريرية المتوافقة مع متطلبات دائرة الصحة بدقة عالية. نقوم بإعداد تحليل شامل للتكاليف بما يتماشى مع متطلبات دائرة الصحة، مما يضمن تكلفة دقيقة للخدمات وتقارير مالية شفافة والامتثال التنظيمي الكامل مع تحسين الربحية والكفاءة التشغيلية.

🔄 حلول الرفض واسترداد المطالبات
قلل من تسرب الإيرادات من خلال الإدارة الذكية للمطالبات. نقوم بتحليل أنماط الرفض وتنفيذ استراتيجيات وقائية وإنشاء عمليات استئناف قوية لتعظيم معدلات السداد وتقليل رفض المطالبات.

📈 تحليل وتحسين دورة الإيرادات
اكتشف فرص الإيرادات الخفية. يحدد تحليل الإيرادات الشامل لدينا نقاط الاختناق ويبسط عمليات الفوترة وينفذ أفضل الممارسات لتسريع التدفق النقدي وتحسين النتيجة النهائية.

🛡️ إدارة المخاطر وضمان الامتثال
احمِ مؤسستك من خلال التخفيف الاستباقي للمخاطر. نقوم بتقييم المخاطر السريرية والتشغيلية والمالية، وتطوير استراتيجيات تخفيف مخصصة، وضمان الامتثال الكامل للوائح الرعاية الصحية المحلية والدولية.

شاركنا لتحويل مؤسستك الصحية إلى منظمة عالية الأداء ومرنة مالياً تقدم رعاية استثنائية للمرضى مع تحقيق التميز التشغيلي.`
    }
  ]
};
